export const formatNumber = function (val) {
    return Number(val).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 3,
    });
};
export const payButtonOptions = [
    {
        label: 'Pay',
        value: 'Pay',
    },
    {
        label: 'Book',
        value: 'Book',
    },
    {
        label: 'Donate',
        value: 'Donate',
    },
];
